<template>
    <div class="donate-page">
        <!-- 1、主要描述内容 -->
        <div class="donate-main-content">
            <div class="donate-main-bottom-bg"></div>
            <div class="donate-main-content-part-zero">
                <p>致各位支持传统文化复兴的朋友们：</p>
            </div>
            <div class="donate-main-content-part-one">
                <p>天时子平项目致力于为易学插上互联网的翅膀，让易学与时代更加融合，扫除封建迷信的历史遗毒，使老祖宗的智慧得到更广泛的传播和应用，造福社会大众。易学因为其特殊性，不被人理解，甚至被煞有心机之人误导，亟需我们共同努力打造和维护一片纯净的文化氛围，消除封建迷信的阴霾。让大家不再只是把它当成一个算命工具，或是用来算股票做暴利做投机倒把的工具，而是更多的通过科学学习，领悟其背后的人与自然的关系，提升自身文化内涵修养，顺应老祖宗创立她的初心，用于趋吉避凶、修身齐家治国平天下。让我们的身心更健康、家庭更和睦、企业更长久、民族更有文化自信、国家更繁荣昌盛！</p>
                <p>正因为易学产生久远，后生晚辈『科学』无法证明她的合理性，而易学教学口口相传又夹杂了老一辈们传下来的古代封建玄而神的理念，历史背景非常特殊，使很多现代人近而远之。在寻找项目资金的时候我们发现多数投资机构看不懂易学项目或者不敢投，基本有三种：一种怕国家政策问题；第二种是怕这种学问太神乎，自己Hold不住；第三种是有疑问能做多大、赚不赚钱。第一个问题其实国家发展趋势摆在那儿，当然是欢迎传统文化复兴，但是得科学接地气，需要一帮有正气、正心、正念又科学接地气的人来传承，这是国家和社会的时代需要。第二个问题就是人们的普及问题了，需要假以时日，我们不就是做这件事嘛；第三个问题，我想大家都看得到很多做易学相关闷声发大财的吧，商业模式无比成熟，但这不是我们的焦点。所以有一些看中这块蓝海市场想暴敛钱财的投机家们找上门，这样的投资我们是不会接受的，这样的投资行为会因为利益驱使随时变味，最终在急功近利的心态下只会欲速而不达，为文化的普及复兴抹黑，损德不利人！我们明确立场不以赢利为目的，重在传承和学习，这将会是一个非常漫长的过程。因此，自然不能获得看重短期投资回报的投行或个人投资者的支持，这些都是可以理解的。</p>
                <p>得益于团队来自于腾讯、阿里等互联网公司且研究易学多年，我们的专业性还算不错，是真正意义上的互联网跨界团队，从产品、开发到美术设计都是易学学习爱好者。产品将涵盖八字、六爻八卦、紫微、大六壬、奇门遁甲、风水罗盘等，让易学工具及平台跟上互联网时代步伐，响应国家关于复兴传统文化的号召，加快打造出全球化、接地气的易学文化平台。我们不会像其它易学软件一样动辄下载个软件使用基础服务还要上百元，我们为大家免费提供专业而好用、易用的工具和平台，让更多爱好者投入到易学的学习和传播中来。</p>
                <p>幸运的是，我们有一群支持易学事业开展，支持文化复兴的热心师兄和朋友。在大家的支持下，我们发起了面向社会的捐赠募集，希望有更多热心人士能够参与到文化复兴进程中来。贡献付出无以为报，为了表示感谢，我们将会在产品中为捐赠的朋友点亮特殊文化大使身份头像；另外，会在贡献榜里面永久记上您的大名，还请各位留下尊姓大名。也邀请各位帮忙点击右上角『…』转发朋友圈或微信群扩散给更多热心人士，我们需要更多有相同理念，愿意为传统文化复兴做点贡献的人加入。易路同行，感恩有您！感谢您的大爱付出！</p>
            </div>
            <div class="donate-main-content-part-two">
                <p class="donate-mc-title">发愿人：天时子平项目团队</p>
                <!-- <p class="donate-mc-title">项目发起人 张真 <span>微信号：beckzhang2019</span></p> -->
                <!-- <p class="donate-mc-title">一生致力于传承易学文化的互联网产品经理</p> -->
                <!-- <ul class="donate-main-content-list">
                    <li>腾讯高级产品经理出身 第一任手机QQ浏览器产品经理</li>
                    <li>前富途证券高级副总裁</li>
                    <li>前游戏上市公司博雅互动高管</li>
                    <li>3W咖啡股东，企业家教练、顾问</li>
                    <li>易学八字讲师，已教授100+企业老板及管理人员ww</li>
                    <li>八字案例过万</li>
                    <li>卦爻、六壬、奇门、紫薇、风水、手面相在研实践</li>
                </ul> -->
            </div>

            <!-- <div class="donate-main-content-part-three">
                <p>天时子平八字主要功能简介</p>
                <p>扫码关注木火八字</p>
            </div> -->
            <div class="donate-main-content-blank"></div>
        </div>
        <!-- 2、底部操作框 -->
        <div class="donate-sub-popup">
            <div class="donate-btn-back" @click="clickBack">
                <i class="iconfont icon-xiangzuo"></i>返回
            </div>
            <div class="donate-btn-support" @click="clickDonate">支持！加油！</div>
            <div class="donate-sub-content">
                <p class="donate-sc-pt">已有<span class="donate-num">{{totalNum}}</span>人为易学文化复兴加油！</p>
                <p>如果您是吃瓜围观群众，也烦请帮忙转发朋友圈，非常感谢。</p>
                <p>如果您对文化教育有特别情怀，有愿力给予更大资金支持，</p>
                <p>请在下面留下您的微信号，</p>
                <p>以便我们及时与您取得联系，再次感谢。</p>
            </div>
            <div class="donate-sub-area dsp-flex">
                <div class="donate-sub-input-box">
                    <span>微信号:</span>
                    <input class="donate-sub-input" v-model="inputValue" @blur="blurInput" type="text">
                </div>
                <div class="donate-button-box">
                    <div @click="clickContact">联系我</div>
                </div>
            </div>
        </div>

        <router-view></router-view>
    </div>
</template>
<script>
import * as doctitle from '../../modules/data/base/doctitle'
import { DOM } from '../../modules/dom';
import { SHARE } from '../../modules/share';
export default {
    name: 'Donate',
    computed: {
        totalNum() {
            return this.$store.state.donate.totalNum;
        }
    },
    data() {
        return {
            inputValue: ''
        }
    },
    mounted() {
        this.$store.dispatch('donate/getDonateInfo');
        DOM.setDocumentTitle('');
        setTimeout(() => {
            this.initDom();
            SHARE.initConfigShare();
        }, 300);
    },
    methods: {
        initDom() {
            // 添加安卓的输入框失去焦点事件监听
            window.onresize = function() {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 10);
            }
        },
        clickBack() {
            var params = this.$router.history.current.params,
                backUrl = params && params.frompage ? '/'+params.frompage : '/home';
            DOM.resetStopTouch();
            this.$store.dispatch('donate/resetData')
            this.$router.replace(backUrl);
        },
        clickDonate() {
            // 获取商品列表再跳转到捐赠页面
            var me = this,
                curPath = this.$router.history.current.path;
            this.$store.dispatch('donate/startSupport', {
                sucCb: function() {
                    me.$router.replace(curPath+'/form');
                    setTimeout(() => {
                        DOM.hideParentPageByClassName('donate-page');
                        DOM.setDocumentTitle(doctitle.TITLE_DONATE_EDIT)
                    }, 20);
                },
                failCb: function() {
                    
                }
            })
        },
        blurInput() {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 10);
        },
        clickContact() {
            console.log('clickContact', this.inputValue)
            if(this.inputValue == '') {
                this.$toast('请先输入微信号');
                return;
            }
            var me = this;
            this.$store.dispatch('donate/setContactMe', {
                type: 1,
                wechatNo: me.inputValue,
                sucCb: function() {
                    me.inputValue = '';
                    me.$toast('谢谢您的信任，我们会尽快联系您的！');
                },
                failCb: function() {
                    me.inputValue = '';
                    me.$toast('哦哦，提交失败，请稍后再试！');
                }
            })
        }

    }
}
</script>